import { useQuery } from '@tanstack/react-query';
import { getFolders } from '../api/getFolders';
import { SearchParams } from './useFilters';

export const GET_FOLDERS_QUERY_KEY = 'templateList';

const useGetFolders = (filters: SearchParams, enabled = true) => {
  const { data: folders, ...rest } = useQuery({
    queryKey: [GET_FOLDERS_QUERY_KEY, filters],
    queryFn: () => getFolders(filters),
    enabled,
  });

  return {
    folders,
    ...rest,
  };
};

export default useGetFolders;
